module.exports = __webpack_public_path__ + "img/jp_lc.94d7a21.png";